const rootArea = "/states";

type REPORTING_STATE = "PENDING" | "DELETED" | "SUBMITTED" | "SUBMITTING";

export const statesGlob = (base: string) => (state?: REPORTING_STATE) => ({
	self: `${base}${rootArea}`,
	copy: `${base}${rootArea}/${state}/copy.execute`
});
